module.exports = __webpack_public_path__ + "img/87.6106510c.jpg";